import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { checkinEntryOptions } from "../../../../constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant";
import { CheckinEntryValidationSchema } from "../../../../schemas/maintenanceForwardingDirectiveSteps.schema";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../../../../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsCheckinEntryStepOptions, MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepCompleted from "../../../CreateForwardingDirectiveEntryFormStepCompleted";

const CheckinEntryFormStepCompleted = ({
  stepIndex,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.CheckinEntry>) => {
  const {
    control,
  } = useFormContext<CheckinEntryValidationSchema>();

  const {
    checkin_entry_type: watchCheckinEntryType,
  } = useWatch({
    control,
  });

  const EntryOptionComponent = useMemo(() => {
    if (watchCheckinEntryType) {
      const checkinEntryOption = checkinEntryOptions[watchCheckinEntryType as MaintenanceForwardingsCheckinEntryStepOptions];

      return checkinEntryOption.components.completed;
    }

    return null;
  }, [watchCheckinEntryType]);

  return (
    <CreateForwardingDirectiveEntryFormStepCompleted
      stepIndex={stepIndex}
      title="Método de check-in"
      body={(
        <div>
          {EntryOptionComponent && (
            <EntryOptionComponent />
          )}
        </div>
      )}
    />
  )
}

export default CheckinEntryFormStepCompleted;
